import './footer.scss';

export default () => {
	const accordions = document.querySelectorAll( '.js-footer-accordion' );

	function openCurrAccordion () {
		for ( let i = 0;i < accordions.length;i += 1 ) {
			const parent = accordions[ i ].parentElement;
			const article = accordions[ i ].nextElementSibling;

			if ( window.matchMedia( '(max-width: 767px)' ).matches ) {
				if ( this === accordions[ i ] && !parent.classList.contains( 'open' ) ) {
					parent.classList.add( 'open' );
					article.style.maxHeight = `${article.scrollHeight}px`;
				} else {
					parent.classList.remove( 'open' );
					article.style.maxHeight = '0px';
				}
			}
		}
	}

	for ( let i = 0;i < accordions.length;i += 1 ) {
		accordions[ i ].addEventListener( 'click', openCurrAccordion );
	}
};
